import { Spinner } from './Spinner';

interface BlockLoaderProps {
  /** Printed under the ring exactly as given. Leave it out for the ring alone. */
  label?: string;
  /** Adds to the block, or replaces its height and padding: "min-h-[400px]", "h-64", "py-16". */
  className?: string;
}

// A class of the caller's that decides how tall the block is: a height, or padding above
// or below. Read plain only; a class behind a breakpoint ("sm:py-16") already wins there.
const SETS_HEIGHT = /^(h|min-h|p|py|pt|pb)-/;

/**
 * A centred block: the large ring, and the words under it when there are any. For where
 * a whole page or a whole panel is still to come.
 *
 * It is py-12 tall unless the caller says otherwise. A caller's own height or vertical
 * padding REPLACES that padding instead of joining it: two padding classes on one
 * element are settled by the order Tailwind emits them, not the order written, and a
 * fixed height shorter than the padding would not be honoured at all.
 */
export function BlockLoader({ label, className = '' }: BlockLoaderProps) {
  const setsOwnHeight = className.split(/\s+/).some((c) => SETS_HEIGHT.test(c));
  const padding = setsOwnHeight ? '' : 'py-12';
  return (
    <div
      role="status"
      aria-label={label ? undefined : 'Loading'}
      className={`flex flex-col items-center justify-center ${padding} ${className}`.replace(/\s+/g, ' ').trim()}
    >
      <Spinner size="lg" />
      {label ? <p className="mt-4 text-sm text-gray-500">{label}</p> : null}
    </div>
  );
}
